/**
 * ID Verification Fingerprint configuration.
 *
 * These values previously lived in the EPIC experiments
 * `AcademicIntegrity.enableIdVerificationFingerprint` (course allowlist) and
 * `AcademicIntegrity.idVerificationFingerprintExclusionList` (excluded learners).
 * Following GA the data rarely changes, so it is hardcoded here instead of
 * being fetched from EPIC. See ING-6227 / ING-6228.
 */

/**
 * Course ids for which ID verification fingerprinting is enabled.
 */
export const ID_VERIFICATION_FINGERPRINT_ENABLED_COURSES: readonly string[] = [
  'Ag847PF9Eeu7_Q6nSq8znw',
  'G8JqXl8VEeu8xgoxFomNmw',
  'XuXxNXKXEe6D4w6kbtK0ww',
  '0ZKfGaZHEe6oQA6J-7B2nw',
  'lf5lYaZHEe6oQA6J-7B2nw',
  'W_kbvIWJEe6hyw4UDDa2MQ',
  '78TEAlGZEe6OZwo2fRssDQ',
  'JClBHF1GEeyDkAqiUF1pDQ',
  'IFyXoV-JEeyGyBIIdSsL5w',
  'yFhU2XzeEe6_Ow7OYY5Yqw',
  'qxv2YV-IEeyGyBIIdSsL5w',
  'uqI54OvjEeyozBJ-29c9rQ',
  'Mbt3FOvlEeyDYwq6z4uKRQ',
  'nmFF2kv8Ee2duhJkJYfIJQ',
  'Dn5CXbw0Ee2u-xIQXc-B6w',
  'j6XXhznOEe2a7QpIshOMSQ',
  'knCQNTnOEe2skBJ6qkJn8w',
  'snwdMb04Ee2PMA5vPCVxYw',
  'PhICSoItEe2cbxIuLDJE9Q',
  'hzaR7jnOEe2skBJ6qkJn8w',
  'l226AZzOEe2p_A5TjZf84Q',
  'UkBKoTbLEe6M6ArdAkKxFQ',
  '_zbQFjbKEe6M6ArdAkKxFQ',
  'TTuOqDBXEe2rxxLf5KsrIw',
  '4MCAf0BEEe6U4g7a-RyA1w',
  'AYWgFX_6Ee6hyw4UDDa2MQ',
  'R9EL6NllEe22vg4tJ4OHzQ',
  '9RiLPF-IEeyIUg4Qv2RsBQ',
  'vtI1A9lYEe22vg4tJ4OHzQ',
  'lr4gGNllEe2hNRJwYmvh7w',
  '1IFPojK_Ee2rxxLf5KsrIw',
  'BcyQ_9llEe22vg4tJ4OHzQ',
  '1xINBDK_Ee2PAQonVRkX_w',
  'XrdKcjbNEe6M6ArdAkKxFQ',
  'IIdbt1xkEe2PNA4WsBh57w',
  'yxYOuA3cEe2Y4woRe4onvw',
  'W1mDHuvfEeyLcA5hHZ0Uxw',
  'wGt_zAZDEe6vlQ6yXaneLQ',
  'M52qQIAAEe6TKg50aC2X7Q',
  'HbBAW9lZEe2hNRJwYmvh7w',
  'jGSIqEq1EfC-nhKAhlSEHQ',
  'oMWK8ZzOEe2p_A5TjZf84Q',
  'ej0JRTnOEe2skBJ6qkJn8w',
  'TEhZHev0EeyLcA5hHZ0Uxw',
  'hl0MwOwBEeyDYwq6z4uKRQ',
  'psqt9ZzOEe2L_wpgKckryw',
  'pYqNMJzOEe2p_A5TjZf84Q',
  'T7BVWTK8Ee2PAQonVRkX_w',
  '1L7heKZeEe6wGxK96EWoDQ',
  '9oosSzbNEe6BFRLuxx0ctw',
  '8wBXoxbbEfCtChLmIEQv9w',
  '-h9chKZeEe6oQA6J-7B2nw',
  'F7HcFUBEEe6M6ArdAkKxFQ',
  'q-VGM7R7Ee2GGAqyWdJs5Q',
  'lcnN9pzOEe2p_A5TjZf84Q',
  '01XvADK_Ee2rxxLf5KsrIw',
  'S8Ct5TbQEe6M6ArdAkKxFQ',
];

/**
 * User ids that are excluded from ID verification fingerprinting.
 * Add a learner's user id here to opt them out of fingerprinting.
 */
export const ID_VERIFICATION_FINGERPRINT_EXCLUSION_LIST: readonly string[] = [
  '67563874',
  '118036568',
  '110932339',
  '128176012',
  '91005146',
  '129344167',
  '22927484',
  '114818385',
  '126134397',
  '103790493',
  '99138177',
  '90938733',
  '38207039',
  '80545762',
];
